import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { ReviewCard, useMyReviewsQuery } from '@/entities/review';
import { DeleteReviewButton } from '@/features/review-delete';
import { reviewEditPath, storeProductPath } from '@/shared/config';
import { Button, buttonVariants } from '@/shared/ui';

export const MyReviewList = (): ReactElement => {
  const reviews = useMyReviewsQuery();
  const items = reviews.data?.pages.flatMap((page) => page.items) ?? [];
  if (reviews.isPending) {
    return (
      <p role="status" className="py-10 text-center text-sm text-muted-foreground">
        후기를 불러오는 중이에요
      </p>
    );
  }
  if (reviews.isError) {
    return (
      <p role="alert" className="py-10 text-center text-sm">
        후기를 불러오지 못했어요.
      </p>
    );
  }
  if (items.length === 0) {
    return <p className="py-10 text-center text-sm text-muted-foreground">아직 쓴 후기가 없어요</p>;
  }
  return (
    <div>
      {items.map((review) => (
        <div key={review.id}>
          <div className="mt-6 flex items-center justify-between">
            <Link to={storeProductPath(review.productId)} className="font-medium">
              {review.productName}
            </Link>
            <div className="flex items-center gap-1">
              {review.status === 'HIDDEN' ? (
                <span className="text-sm text-muted-foreground">숨김 처리됨</span>
              ) : (
                <Link
                  to={reviewEditPath(review.id)}
                  className={buttonVariants({ variant: 'ghost', size: 'sm' })}
                >
                  수정
                </Link>
              )}
              <DeleteReviewButton review={review} />
            </div>
          </div>
          <ReviewCard review={review} />
        </div>
      ))}
      {reviews.hasNextPage ? (
        <div className="mt-6 flex justify-center">
          <Button
            variant="outline"
            disabled={reviews.isFetchingNextPage}
            onClick={() => void reviews.fetchNextPage()}
          >
            더 보기
          </Button>
        </div>
      ) : null}
    </div>
  );
};
